/* @ngInject */
export default class CashflowStatementNewCtrl {
    constructor(
        $sce,
        $scope,
        $state,
        Utility,
        $timeout,
        $rootScope,
        BuildingsService,
        FinancialsService,
        LocalStorageService,
        NotificationService,
        CashflowStatementDataNewService,
        AuthorizationService
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.FinancialsService = FinancialsService;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.CashflowStatementDataNewService = CashflowStatementDataNewService;
        this.AuthorizationService = AuthorizationService;
        this.statusInformation = null;
        this._switchIsBusyLoading(true);
        this.init();
        this.activate();
    }

    init() {
        this._switchIsBusyLoading(true);
        this.today = this.Utility.getFormatedDate(new Date());
        this.selectedDate = this.Utility.getFormatedDate(new Date());
        this.selectedDateYear = this.Utility.getFormatedDate(new Date());
        this.filterYear = this.selectedDate;
        this.filterMonth = this.selectedDateYear;
        this.selectedBuildingRef = '';
        this.selectedBuildingName = '';
        this.isFilterActive = true;
        this.isMonthlyView = true;
        this.iframePaymentDocuments = '';
    }

    openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    _switchIsBusyLoading(flag) {
        this.$timeout(() => {
            this.isLoading = flag;
        });
    }

    allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

    async activate() {
        this.serviceData = this.CashflowStatementDataNewService;
        this.financialsServiceData = this.FinancialsService;
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
        const userProfile = this.LocalStorageService.retrieve('userProfile');
        var buildingName = '';
        if (userProfile) {
            if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
            const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
                return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
            });

            if (selectedBuilding) {
                buildingName = selectedBuilding.SchemeName;
            }
        }
        await this.getFinancialYears(true);
        this.selectedBuildingName = buildingName;
        var temp = await this.FinancialsService.setReportURL(this.selectedBuildingRef, this.selectedDate);
        $("#mobileLink").attr("href", temp);
        $('.StartCollapse').collapse();
    }

    async filterByCurrentMonth() {
        this.isFilterActive = true;
        this.selectedDate = this.Utility.getFormatedDate(new Date());
        await this.getNewCashflowStatement();
    }

    async filterByMonth() {
        this.$timeout(async () => {
            if (this.filterMonth) {
                this.selectedDate = this.Utility.getFormatedDate(this.filterMonth);
                await this.getNewCashflowStatement();
                var temp = await this.FinancialsService.setReportURL(this.selectedBuildingRef, this.selectedDate);
                $("#mobileLink").attr("href", temp);
            }
        });
    }

    async filterByYear() {
        this.filterMonth = '';
        this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
        if (this.isMonthlyView) {
            await this.getFinancialMonths(this.selectedDateYear);
        } else {
            this.selectedDate = this.Utility.getFormatedDate(this.filterYear);
            await this.getNewCashflowStatement();
        }
    }

    async getNewCashflowStatement() {
        this._switchIsBusyLoading(true);
        try {
            await this.CashflowStatementDataNewService.getNewCashflowStatement(this.selectedBuildingRef,
                this.Utility.getFormatedDate(this.filterMonth));
            await this.getFinancialState();
        } catch (err) {
            console.error(`Error while loading Income Statement`, err);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    _filterOutFutureMonths() {
        const today = new Date();
        const formatedDate = moment(today).format('YYYY MMMM');
        const currentYear = formatedDate.split(' ')[0];
        const currentMonth = formatedDate.split(' ')[1];

        let foundIndex = -1;
        const found = this.financialsServiceData.financialMonths.find((month, index) => {
            const fields = month.FriendlyNameMonth.split(' ');
            const yearStr = fields[1];
            const monthStr = fields[0];
            const found = currentYear === yearStr && currentMonth === monthStr;

            if (found) {
                foundIndex = index;
            }
            return found;
        });

        if (found && foundIndex > -1) {
            const filteredMonths = this.financialsServiceData.financialMonths.filter(
                (month, index) => index < foundIndex + 1
            );

            if (filteredMonths && filteredMonths.length < this.financialsServiceData.financialMonths.length) {
                this.financialsServiceData.financialMonths = filteredMonths;
            }
        }
    }

    async getSelectedDate(isInit) {
        const selectedDateYear = this.financialsServiceData.getSelectedYear();
        if (isInit) {
            let index = 0;
            for (let i = 0; i < this.financialsServiceData.financialYears.length; i++) {
                const yearRaw = this.financialsServiceData.financialYears[i];

                if (selectedDateYear.isBetween(yearRaw.WhenFrom, yearRaw.WhenTo)) {
                    index = i;
                    this.filterYear = this.financialsServiceData.financialYears[i].WhenTo;
                    this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);

                    break;
                }
            }

            const date = selectedDateYear ? selectedDateYear : new Date();
            await this.getFinancialMonths(date, true);
        }
    }

    async getFinancialYears(isInit) {
        this._switchIsBusyLoading(true);

        try {
            await this.financialsServiceData.getFinancialYears(this.selectedBuildingRef, this.today);
            if (isInit) {
                await this.getSelectedDate(true);
            } else {
                this.filterYear = this.financialsServiceData.financialYears[
                    this.financialsServiceData.financialYears.length - 1
                ].WhenTo;
                this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
                await this.getIncomeStatement();
            }
        } catch (err) {
            console.error(`Error loading Financial Years`, err);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async getFinancialMonths(date, isInit) {
        this._switchIsBusyLoading(true);
        try {
            await this.financialsServiceData.getFinancialMonths(this.selectedBuildingRef, date || new Date());
            let selectedMonthIndex = -1;

            const selectedDateMonth = await this.financialsServiceData.getSelectedMonth();

            if (selectedDateMonth) {
                if (this.financialsServiceData.financialMonths && this.financialsServiceData.financialMonths.length > 0) {
                    const foundMonth = this.financialsServiceData.financialMonths.find((month, index) => {
                        const momentMonth = moment(month.WhenFrom);
                        if (momentMonth.isSame(selectedDateMonth, 'month')) {
                            selectedMonthIndex = index;
                            return true;
                        }
                    });

                    if (selectedMonthIndex > -1 && foundMonth) {
                        this.filterMonth = this.financialsServiceData.financialMonths[selectedMonthIndex].WhenFrom;
                        this._filterOutFutureMonths();
                    }
                }
            } else if (date && isInit) {
                this.financialsServiceData.financialMonths.filter(async (month, i) => {
                    const monthDateStr = month.WhenFrom.substr(0, 10);
                    const monthDate = moment(new Date(monthDateStr), 'YYYY-DD-MM');
                    const selectedMonth = await this.financialsServiceData.getSelectedMonth();

                    if (monthDate.isSame(selectedMonth, 'month')) {
                        selectedMonthIndex = i;
                        return true;
                    }
                });

                if (selectedMonthIndex === -1) {
                    this.filterMonth = '';
                } else {
                    this.filterMonth = this.financialsServiceData.financialMonths[selectedMonthIndex].WhenFrom;
                }
            } else if (isInit) {
                this.filterMonth = this.financialsServiceData.financialMonths[
                    this.financialsServiceData.financialMonths.length - 1
                ].WhenFrom;
            }

            if (this.filterMonth) {
                this.selectedDate = this.filterMonth;
                await this.getNewCashflowStatement();
            }
        } catch (err) {
            console.error(`Error while loading financial months\n${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    navigateToLevyRoll() {
        this.$timeout(() => {
            angular.element('#levyrollViewModal').modal('hide');
            angular.element('#levyrollViewModal').on('hidden.bs.modal', () => {
                this.$rootScope.$broadcast('navigate-changed', 'levy-roll', { date: this.filterMonth });
            }); 
        });
    }

    async accountClick(accountCode, event, type) {
        const element = angular.element(event.currentTarget)[0];
        const { className } = element;

        if (!className.includes('lastLevel') && !className.includes('clickable')) {
            this.CashflowStatementDataNewService.transactions[accountCode] = [];
            return;
        }

        switch (accountCode) {
            case '12000':
                break;
            case '12020':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode, true);
                break;
            case '12025':
                await this.showStatement(accountCode);
                break;
            case '12000':
            case '12050':
            case '13000':
                this.CashflowStatementDataNewService.transactions[accountCode] = [];
                break;
            case '12030':
            case '12035':
            case '12040':
            case '12045':
                await this.showStatement(accountCode);
                break;
            case '400000':
                angular.element('#levyrollViewModal').modal('show');
                break;
            case '400075':
                angular.element('#levyrollViewModal').modal('show');
                break;
            case '1':
                this.saveSelectedDate();
                angular.element('#nagNavigation').modal('show');
                break;
            case '41005':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode, true);
                break;
            case '62700':
                await this.showPolicy();
                break;
            case '62900':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode);
                //TODO: show Payslip
                //TODO: remove getTransactions(accountCode);
                break;
            default:
                if (accountCode.length === 5) {
                    this._handleAccordionToggle(type, accountCode);
                    await this.getTransactions(accountCode);
                }
        }
    }

    async showBankStatement(accountCode, date, lineMemo) {
        try {
            date = date.split('-');
            date[date.length - 1] = '01';
            date = date.join('-');
            const results = await this.CashflowStatementDataNewService.getInterestTransactionDetails(accountCode, date);

            await this.previewBankStatement(results, lineMemo);
        } catch (error) {
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfount.co.za/error'
                },
                attachments: []
            };
            console.error(`Error while loading Bank Statement: `, error);
            this.NotificationService.error(`Error loading transaction or bank statement: ${accountCode}`);
        } finally {
        }
    }

    async previewBankStatement(records, lineMemo) {
        this.investmentStatment = {};

        try {
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: ''
                },
                attachments: []
            };
            if (lineMemo) {
                for (var i = 0; i < records.length; i++) {
                    if (lineMemo.includes(records[i].Description)) {
                        this._mapStatements(i);
                    }
                }
            } else {
                this._mapStatements();
            }

            this.$timeout(() => angular.element('#investmentBankStatementQueryModal').modal('show'));
        } catch (error) {
            const msg = 'Error loading statement';
            console.error(`${msg}`, error);
            this.investmentStatment = {};
            this.NotificationService.error(msg);
        }

        return;
    }

    _mapStatements(index = 0) {
        let { statements } = this.CashflowStatementDataNewService;
        statements = statements.map((statement) => {
            return {
                ...statement,
                documentsUrl: this._idToFilePath(statement.Id)
            };
        });

        const Attachments = statements;
        this.investmentStatment = {
            Attachments,
            attachments: statements,
            currentAttachment: statements[index]
        };
    }

    _idToFilePath(id) {
        const path = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
            ? ''
            : '/'}documents/byid/${id}/?handleNotFound=false`;

        return this.$sce.trustAsResourceUrl(path);
    }

    async showStatement(accountCode) {

        this.investmentStatment = {
            currentAttachment: {
                documentsUrl: ''
            },
            attachments: []
        };

        try {
            const results = await this.CashflowStatementDataNewService.loadStatements(
                this.selectedBuildingRef,
                this.filterMonth,
                accountCode
            );
            this.investmentStatment.attachments = results.map((file) => {
                const attachmentUrl = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
                    ? ''
                    : '/'}documents/byid/${file.Id}/?handleNotFound=false`;
                file.documentsUrl = this.$sce.trustAsResourceUrl(attachmentUrl);

                return file;
            });

            this.investmentStatment.currentAttachment = this.investmentStatment.attachments[0];
        } catch (err) {
            console.error(`Error while loading statement\n${err}`);
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfount.co.za/error'
                },
                attachments: []
            };
        } finally {
            this.$timeout(() => {
                angular.element('#investmentBankStatementQueryModal').modal('show');
            });
        }
    }

    async accountClickYear(accountCode, event, type) {
        await this.getTransactionsForYear(accountCode);
        this._handleAccordionToggle(type, accountCode);
    }

    async getTransactionsForYear(accountCode, selectedDate = null) {
        this.setIsLoadingTranstactions(accountCode, true);

        try {
            const payload = {
                accountCode,
                schemeRef: this.selectedBuildingRef,
                date: selectedDate ? selectedDate : this.selectedDate
            };

            await this.CashflowStatementDataNewService.getTransactionsForYear(payload);
        } catch (err) {
            console.error(`Error while loading transactions for year\n${err}`);
        } finally {
            this.setIsLoadingTranstactions(accountCode, false);
        }
    }

    _handleAccordionToggle(type, accountCode) {
        const $accordion = angular.element(`#${type}-${accountCode}`);
        const isExpanded = $accordion.hasClass('in');

        if (!isExpanded) {
            this.$timeout(() => {
                $accordion.collapse('show');
            });
        }
    }

    async getTransactions(accountCode, isInterest, selectedDate = null) {
        this.setIsLoadingTranstactions(accountCode, true);

        try {
            await this.CashflowStatementDataNewService.getTransactions(
                this.selectedBuildingRef,
                selectedDate ? selectedDate : this.selectedDate,
                accountCode,
                isInterest
            );
        } catch (err) {
            console.error(`Error while loading transactions\n${err}`);
        } finally {
            this.setIsLoadingTranstactions(accountCode, false);
        }
    }

    get monthsToDate() {
        if (!!!this.filterMonth) {
            return;
        }

        let results;
        const selectedYearMoment = moment(this.filterMonth);
        const selectedYear = this.FinancialsService.financialYears.find((financialYear) => {
            const { WhenTo, WhenFrom } = financialYear;
            const whenToMoment = moment(WhenTo);
            const whenFromMoment = moment(WhenFrom);

            let isFound =
                whenFromMoment.isSameOrBefore(selectedYearMoment) && whenToMoment.isSameOrAfter(selectedYearMoment);

            return isFound;
        });

        if (selectedYear) {
            const { WhenFrom } = selectedYear;
            const whenFromMoment = moment(WhenFrom);
            results = `${whenFromMoment.format('MMM YYYY')} - ${selectedYearMoment.format('MMM YYYY')}`;
        }

        return results;
    }

    get yearToDate() {
        if (!!!this.filterMonth) {
            return;
        }

        let results;
        const selectedFrom = moment(this.selectedDateYear).add('year', -1).add('day', 1);
        const selectedTo = moment(this.selectedDateYear).add('day', -1);
        results = `${selectedFrom.format('MMM YYYY')} - ${selectedTo.format('MMM YYYY')}`;

        return results;
    }

    async getFinancialState() {
        const type = 0;
        const schemeRef = this.selectedBuildingRef;
        const momentDate = moment(this.selectedDate, 'YYYY-MM-DD');
        const formattedDate = momentDate.format('YYYY-MM-DD');
        const date = `${formattedDate.substr(0, 8)}01`;

        this._switchIsBusyLoading(true);
        try {
            const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

            const { status, message } = results;
            this.statusInformation = message;
        } catch (error) {
            this.NotificationService.error('Error loading cashflow statement status');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    setIsLoadingTranstactions(accCode, isBusy) {
        this.$timeout(() => {
            if (!this.isLoadingTransactions) {
                this.isLoadingTransactions = {};
            }

            this.isLoadingTransactions[accCode] = isBusy;
        });
    }

    async showPolicy() {
        this._switchIsBusyLoading(true);
        this.policyDocument = {
            currentAttachment: {
                documentsUrl: ''
            },
            attachments: []
        };

        try {
            const results = await this.CashflowStatementDataNewService.loadPolicyDocuments(this.selectedBuildingRef);
            this.policyDocument.attachments = results.map((file) => {
                const attachmentUrl = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
                    ? ''
                    : '/'}documents/byid/${file.Id}/?handleNotFound=false`;
                file.documentsUrl = this.$sce.trustAsResourceUrl(attachmentUrl);

                return file;
            });

            this.policyDocument.currentAttachment = this.policyDocument.attachments[0];

            this.$timeout(() => angular.element('#policyDocumentModal').modal('show'));
        } catch (err) {
            this.policyDocument = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfound.co.za/error'
                },
                attachments: []
            };
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async showStatement(accountCode) {
        this.investmentStatment = {
            currentAttachment: {
                documentsUrl: ''
            },
            attachments: []
        };

        try {
            const results = await this.CashflowStatementDataNewService.loadStatements(
                this.selectedBuildingRef,
                this.filterMonth,
                accountCode
            );
            this.investmentStatment.attachments = results.map((file) => {
                const attachmentUrl = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
                    ? ''
                    : '/'}documents/byid/${file.Id}/?handleNotFound=false`;
                file.documentsUrl = this.$sce.trustAsResourceUrl(attachmentUrl);

                return file;
            });

            this.investmentStatment.currentAttachment = this.investmentStatment.attachments[0];
        } catch (err) {
            console.error(`Error while loading statement\n${err}`);
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfount.co.za/error'
                },
                attachments: []
            };
        } finally {
            this.$timeout(() => {
                angular.element('#investmentBankStatementQueryModal').modal('show');
            });
        }
    }

    async showPayment(payment) {
        this._switchIsBusyLoading(true);
        this.webPaymentApprovalIndividual = undefined;
        this.iframePaymentDocuments = undefined;
        if (typeof payment != 'undefined' && payment != null) {
            this.webPaymentApprovalIndividual = payment;

            for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                    const { Path, DocumentExtension } = this.webPaymentApprovalIndividual.Attachments[j];
                    const pathToLowerCase = Path.toLowerCase();
                    let url = '';

                    if (!pathToLowerCase.endsWith(`${DocumentExtension.toLowerCase()}`)) {
                        url = `${Path}${DocumentExtension ? DocumentExtension.toLowerCase() : ''}`;
                    } else {
                        url = Path;
                    }

                    this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(url);
                }
            }
        } else {
            this._switchIsBusyLoading(false);
            return;
        }
        this._switchIsBusyLoading(false);
        angular.element('#paymentViewModal').on('show.bs.modal', (evt) => {
            if (!!this.iframePaymentDocuments) {
                this.getInvoicePath(0);
            }
        });
        this.$timeout(() => {
            angular.element('#paymentViewModal').modal('show');
        });
        return;
    }

    getInvoicePath(index) {
        this.iframePaymentDocuments = undefined;
        const { Path, DocumentExtension } = this.webPaymentApprovalIndividual.Attachments[index];
        const pathToLowerCase = Path.toLowerCase();

        let url;
        if (!!DocumentExtension && !pathToLowerCase.endsWith(`${DocumentExtension.toLowerCase()}`)) {
            url = `${Path}${DocumentExtension}`;
        } else {
            url = Path;
        }

        this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(url);
    }

    async getReport() {
        this._switchIsBusyLoading(true);

        try {
            this.reportModelHeader = `${this.selectedBuildingName} - Cashflow To Budget - ${moment(
                this.selectedDate
            ).format('MMM YYYY')}`;
            await this.financialsServiceData.getReport(
                this.selectedBuildingRef,
                this.selectedDate,
                11,
                this.reportModelHeader
            );
        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

}
